import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./CustomCarousel.css"

class CustomCarousel extends Component {
	constructor(props) {
		super(props);
        let data = {...props.data};

        let hoverItem;

        // Check if a element of the list has a 'hover' property and get its index.
        data.dates.map((item, index)=>{
            item.hover ? hoverItem = index : null;
        })
    
		this.state = {
            data: data,
			options: {
                margin: 30,
                dots: false,
                nav: true,
                slideTransition: 'linear',
                autoWidth: true,
                touchDrag  : true,
                mouseDrag  : true,
                slideSpeed : 600,
                paginationSpeed : 800,
                singleItem:true,
                // Let's start with element marked as hover
                startPosition: hoverItem
			}
		};
		//console.log("CustomCarousel: ", this.state);
	}

	render() {

        return(
            <OwlCarousel className="custom-carousel" {...this.state.options}>
                {this.state.data.dates.map((item, index)=>{
                    // If the element has the 'hover' property give'em a class.
                    let hover = item.hover ? "hover" : null;
                    return(
                        item.link ? (
                            <div key={index}>
                                <Link to={item.link}>
                                    <div className={`title ${hover}`}>{item.text}</div>
                                </Link>
                            </div>
                        ) : (
                            <div key={index}>
                                <div className={`title unactive ${hover}`}>{item.text}</div>
                            </div>
                        )
                    )
                })}
            </OwlCarousel> 
        )
	}
}

export default CustomCarousel;



// WEBPACK FOOTER //
// ./src/Components/Elements/CustomCarousel/index.jsx